export const fieldsToCompareForConfidenceLevel = ['artaSubtype', 'depth', 'height', 'isFragile', 'unitOfMeasurement', 'width'];
